module.exports = __webpack_public_path__ + "img/aztec_320.698c2c45.png";